import React from 'react'
import { Popover, Divider } from 'antd'
import { UpOutlined, DownOutlined, PauseOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { Pluralize } from '../../../utils/common'
import stripeBg from '../../../asserts/images/Stripe-line.png'
// import gradientBg from '../../../asserts/images/Gradient-line.png'
import moment from 'moment'
import { getColor } from './healthyCompactView'
import Debooster from '../../../asserts/icon/debooster.svg'
import booster from '../../../asserts/icon/booster.svg'

const Container = styled.div`
  padding-right: 52px;
  position: relative;
  & > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 0;
    &:last-child {
      padding: 0;
    }
  }
  .range-bar {
    color: #c0c7d1;
    font-size: 12px;
    width: 358px;
    display: flex;
    justify-content: space-between;
  }
  .range-gride {
    position: absolute;
    right: 52px;
    top: -10px;
    .bar-gride {
      width: 358px;
      display: flex;
      justify-content: space-between;
      .ant-divider-vertical {
        height: 115px;
        border-color: #c9c9c9;
        margin: 0;
        border-style: dashed;
        border-width: 1px;
      }
    }
  }
`

// const ranges = [0, 25, 50, 100, 200, 300, 400, 500]

export default function HealthyDataView(props) {
  let { data, barLabels, target } = props // hightestValue
  data = data || {}
  const hightestValue = Math.max(target, data.seg_pct, data.more_seg_pct_avg)
  const step = Math.round((hightestValue * 1.25) / 3)
  const ranges = [0, step, step * 2, step * 3]
  const bars = [
    {
      label: barLabels[0],
      widthReference: 'seg_pct',
      seg_pct: data.seg_pct,
      workouts: data.seg_workouts,
      target,
      hightestValue
    },
    {
      label: barLabels[1],
      widthReference: 'more_seg_pct_avg',
      seg_pct: data.more_seg_pct_avg,
      hightestValue
    }
  ]
  return (
    <Container>
      <div className="range-gride">
        <div />
        <div className="bar-gride">
          {ranges.map((_, index) => (
            <Divider type="vertical" key={index} />
          ))}
        </div>
      </div>
      {bars.map((bar, index) => (
        <HealthySegment {...bar} key={index} data={data} ranges={ranges} />
      ))}
      <div>
        <div />
        <div className="range-bar">
          {ranges.map((value, index) => (
            <span key={index}>{value}</span>
          ))}
        </div>
      </div>
    </Container>
  )
}

export const getGradientRanges = (target) => {
  const gray = '#BBCCDE',
    blue = '#2F8CE9',
    green = '#A7C22A',
    yellow = '#FFC402'
  if (target <= 100) {
    return [
      { color: gray, offset: 0 },
      { color: blue, offset: 1 }
    ]
  } else if (target <= 200) {
    return [
      { color: blue, offset: 0 },
      { color: green, offset: 1 }
    ]
  } else {
    return [
      { color: blue, offset: 0 },
      { color: green, offset: 0.7098 },
      { color: yellow, offset: 1 }
    ]
  }
}

function SEGPCT(props) {
  const {
    width,
    hidePCTText,
    text: pct,
    target,
    targetWidth,
    showTargetLine,
    hightestValue
  } = props
  let x = (358 * Number(width.replace('%', ''))) / 100
  let targetX = 0
  if (targetWidth) {
    targetX = Math.round((358 * Number(targetWidth.replace('%', ''))) / 100) - 5
  }

  let textAnchor = 'start'

  const pctColor = getColor(pct, hightestValue),
    targetColor = getColor(target, hightestValue)

  const pctTextWidth = pct > 99 ? 35 : pct > 9 ? 25 : 16
  const deviation = !(targetX + 10 < x || targetX > x + pctTextWidth)
  const linearRanges = getGradientRanges(hightestValue)

  return (
    <svg
      width="400" //"358"
      height="70"
      viewBox="0 0 400 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {!hidePCTText && pct > 0 && (
        <>
          {targetX > x && (
            <rect width={pctTextWidth} height="14" x={x} y={18} fill="white" />
          )}
          <text
            textAnchor={textAnchor}
            fontSize={14}
            x={x}
            y="30"
            fill={pctColor}
            transform="translate(5, 0)"
          >
            {pct}
          </text>
        </>
      )}
      <rect width="2" height="14" x={x - 2} y={18} fill={pctColor} />

      {targetWidth &&
        (showTargetLine ? (
          // <line
          //   x1={targetX + 4}
          //   y1="34"
          //   x2={targetX + 4}
          //   y2="14"
          //   stroke={targetColor}
          //   strokeWidth="2"
          //   strokeLinecap="round"
          //   strokeDasharray="4 4"
          // />
          <g
            // transform={`translate(0, ${deviation ? 0 : 20})`}
            transform={'translate(0, 20)'}
            fill={target <= pct && !deviation ? 'white' : targetColor}
          >
            <circle cx={5 + targetX} cy="5" r="5" />
            <circle
              cx={4.99998 + targetX}
              cy="4.99998"
              r="3.4"
              fill={target <= pct && !deviation ? targetColor : 'white'}
            />
            <circle cx={5 + targetX} cy="5" r="2" />
          </g>
        ) : (
          <g
            transform={`translate(0, ${deviation ? 0 : 20})`}
            fill={target <= pct && !deviation ? 'white' : targetColor}
          >
            <text
              x={targetX + 5}
              y={-10}
              textAnchor={targetX + 5 > 32 ? 'middle' : 'start'}
              fontSize={11}
              fill="#52606C"
            >
              Target: {target}
            </text>
            <circle cx={5 + targetX} cy="5" r="5" />
            <circle
              cx={4.99998 + targetX}
              cy="4.99998"
              r="3.4"
              fill={target <= pct && !deviation ? targetColor : 'white'}
            />
            <circle cx={5 + targetX} cy="5" r="2" />
          </g>
        ))}

      <defs>
        <linearGradient id="paint0_linear_48924_37147">
          {linearRanges.map(({ color, offset }, index) => (
            <stop stopColor={color} offset={offset} key={index} />
          ))}
        </linearGradient>
      </defs>
    </svg>
  )
}

const PopContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #5b6177;
  font-size: 10px;
  font-weight: 600;
  .score {
    width: 46px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    margin-left: 32px;
    margin-bottom: 20px;
    border-radius: 100%;
    background: #f6f6f7;
    color: #3d4358;
    font-size: 17px;
    font-weight: 700;
    font-family: 'Inter';
  }
  .score-value-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }  
  .name {
    margin-bottom: 10px;
    span {
      color: #94a3af;
      font-size: 8px;
    }
  }
  .info {
    display: flex;
    & > div {
      min-width: 42px;
      margin-right: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
    }
    span {
      color: #94a3af;
      font-size: 8px;
    }
  }
`

const getGradient = (target) => {
  if (target <= 100) {
    return '90deg, #BBCCDE 0%, #2F8CE9 100%'
  } else if (target <= 200) {
    return '90deg, #2F8CE9 0%, #A7C22A 100%'
  } else {
    return '90deg, #2F8CE9 0%, #A7C22A 70.98%, #FFC402 100%'
  }
}
const SegmentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  color: #5b6177;
  font-size: 10px;
  font-weight: 500;
  margin-right:  ${(props) => (props.useSleepModifiedDataView ? '164px' : '0px')};
  .bar-container {
    width: 358px;
    height: 8px;
    position: relative;
    & > div {
      width: 100%;
      height: 8px;
    }
    .stripe-bg {
      background: url(${stripeBg});
      background-size: 358px;
      border-radius: 13px;
    }
    .gradient-bg-container {
      overflow: hidden;
      border-radius: 13px 0 0 13px;
      position: absolute;
      top: 0;
      height: 8px;
    }
    .gradient-bg {
      background: linear-gradient(${(props) => getGradient(props.target)});
      width: 358px;
      height: 8px;
    }
    svg {
      position: absolute;
      top: -52px;
    }
  }
  .workout-container {
    position: absolute;
    top: -1px;
    display: flex;
    z-index: 9;
    .workout-item {
      border: 1px solid #ffffff;
      height: 10px;
      position: absolute;
      &:first-child {
        border-radius: 13px 0 0 13px;
      }
      &:last-child {
        border-right: none;
        border-width: 0;
      }
      &:hover {
        border-color: #0272e1;
        border: 1px solid;
      }
    }
  }
`

export function HealthySegment(props) {
  const {
    label,
    data,
    target,
    widthReference,
    workouts,
    seg_pct,
    hidePCTText,
    showTargetLine,
    ranges,
    hightestValue,
    useModfiedSleepDataView,
    healthySignalsData,
    domain_label,
    sleepDataAvg
  } = props
  const width = getBarPCTWidth(seg_pct, ranges) + '%'
  const targetWidth = target && getBarPCTWidth(target, ranges) + '%'
  return (
    <SegmentContainer target={hightestValue} useModfiedSleepDataView={useModfiedSleepDataView}>
      <div>{label}</div>
      <div className="bar-container">
        {target && (
          <div className="stripe-bg" style={{ width: targetWidth }}></div>
        )}
        <div className="gradient-bg-container" style={{ width }}>
          <div className="gradient-bg"></div>
        </div>
        <SEGPCT
          width={width}
          hidePCTText={hidePCTText}
          text={seg_pct}
          target={target}
          hightestValue={hightestValue}
          targetWidth={targetWidth}
          showTargetLine={showTargetLine}
        />
        {workouts && renderWorkouts(workouts, domain_label, seg_pct, healthySignalsData, useModfiedSleepDataView, sleepDataAvg)}
      </div>
    </SegmentContainer>
  )

  function renderWorkouts(workouts, domain_label, totalPCT, healthySignalsData, useModfiedSleepDataView, sleepDataAvg) {
    let ratio = 1
    let totalPct = 0,
      position = 0
    for (const workout of workouts) {
      const { hsd_pct } = workout
      totalPct += hsd_pct
      const width = getBarPCTWidth(totalPct * ratio, ranges)
      workout.left = position + '%'
      workout.width = width - position + '%'
      position = width
    }

    return (
      <div className="workout-container">
        {workouts.map((workout, index) => {
          const { start_time, record_date } = workout
          let showDate
          if (start_time) {
            showDate = moment(start_time * 1000).utc().subtract(8, 'hours').format('h:mm A - MMM D, YYYY')
          } else if (record_date) {
            showDate = moment(record_date).format('MMM D, YYYY')
          }

          const getModifiedValue = (domain, recordDate, healthySignalsData, workoutScore, workouts) => {
            if (!domain || !healthySignalsData || !workouts) return null

            const matchedEntry = Array.isArray(healthySignalsData) && healthySignalsData.find(entry => entry.record_date === recordDate)
            if (!matchedEntry) return null

            const modifiedKey = `${domain}_modified`
            const totalModifierValue = matchedEntry[modifiedKey] !== undefined ? matchedEntry[modifiedKey] : null
            if (totalModifierValue === null) return null

            const totalScoreForDate = workouts
              .filter(workout => workout.record_date === recordDate)
              .reduce((sum, workout) => sum + workout.hsd_pct, 0)

            if (totalScoreForDate === 0) return null

            return (workoutScore / totalScoreForDate) * totalModifierValue
          }

          const workoutScore = workout.hsd_pct

          return (
            <Popover
              placement="top"
              overlayClassName="popover-no-arrow popover-for-HSD"
              title={null}
              content={
                <PopContent>
                  <div>
                    <div className="name">
                      {workout.activity_type_shown || workout.type}
                      <br />
                      {showDate && <span>{showDate}</span>}
                    </div>

                    <div className="info">
                      {/* Sleep Booster: Show up/down/equal for duration, efficiency, hrv vs avg */}
                      {workout.activity_type_shown === 'Sleep Booster' && sleepDataAvg ? (
                        <>
                          <div>
                            <span>Duration</span>

                            {(() => {
                              const avg = sleepDataAvg.avgSleepDuration
                              const val = workout.duration
                              const hours = Math.floor((val || 0) / 3600);
                              const mins = Math.round(((val || 0) % 3600) / 60);
                              const duration = `${hours > 0 ? hours + 'h ' : ''}${mins > 0 ? mins + 'm' : ''}`;
                              if (!val) return 'NA'
                              if (Math.abs(val - avg) <= 0.5 * 60 * 60) return <div>{duration}</div>
                              if (val < avg - 0.5 * 60 * 60) return <div><img src={Debooster} alt="Deboosted" /> <span style={{ fontSize: 10, color: '#5b6177' }}> {duration}</span></div>
                              if (val > avg + 0.5 * 60 * 60) return <div><img src={booster} alt="Boosted" /><span style={{ fontSize: 10, color: '#5b6177' }}> {duration}</span></div>
                              return <div> {duration}</div>
                            })()}
                          </div>
                          <div>
                            <span>Efficiency</span>

                            {(() => {
                              const avg = sleepDataAvg.avgSleepEfficiency
                              const val = workout.intensity ? Number(workout.intensity.replace('%', '')) : null
                              if (!val) return 'NA'
                              if (Math.abs(val - avg) <= 0.5) return <div> {val}</div>
                              if (val < avg - 0.5) return <div><img src={Debooster} alt="Deboosted" /> <span style={{ fontSize: 10, color: '#5b6177' }}> {val}%</span></div>
                              if (val > avg + 0.5) return <div><img src={booster} alt="Boosted" /> <span style={{ fontSize: 10, color: '#5b6177' }}> {val}%</span></div>
                              return <div> {val}%</div>
                            })()}
                          </div>
                          <div>
                            <span>HRV</span>

                            {(() => {
                              const avg = sleepDataAvg.avgSleepHrv
                              const val = workout.hrv ? Number(workout.hrv) : 0
                              if (!val) return 'NA'
                              if (Math.abs(val - avg) <= 0.5) return <div> {val}</div>
                              if (val < avg - 0.5) return <div><img src={Debooster} alt="Deboosted" /> <span style={{ fontSize: 10, color: '#5b6177' }}> {val}</span></div>
                              if (val > avg + 0.5) return <div><img src={booster} alt="Boosted" /> <span style={{ fontSize: 10, color: '#5b6177' }}> {val}</span></div>
                              return <div> {val}</div>
                            })()}
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <span>Time</span>

                            {`${Math.round(workout.duration / 60)} ${Pluralize('min', Math.round(workout.duration / 60) || 1)}`}
                          </div>
                          <div>
                            <span>Intensity</span>

                            {workout.intensity}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="score-value-container">
                    <div className="score">{workout.hsd_pct}</div>
                    {/* <div
                      className="name"
                      style={{
                        marginBottom: '22px'
                      }}
                    >
                      {useModfiedSleepDataView && (
                        <span
                          style={{
                            display: 'block',
                            marginBottom: '-14px'
                          }}
                        >
                          Sleep Modifier
                        </span>
                      )}
                      <br />
                      {[
                        'aerobic',
                        'bone',
                        'body_composition',
                        'balance',
                        'muscle_fitness',
                        'movement_quality',
                        'cognitive_health'
                      ]
                        .filter((domainFromHSD) =>
                          domain_label
                            .toLowerCase()
                            .includes(domainFromHSD.split('_')[0].toLowerCase())
                        )
                        .map((domain) => {
                          const modifiedValue = getModifiedValue(
                            domain,
                            workout.record_date,
                            healthySignalsData,
                            workoutScore,
                            workouts
                          )
                          return (
                            <div key={domain}>
                              {typeof modifiedValue === 'number' &&
                                modifiedValue !== workoutScore && (
                                  <span style={{ marginRight: '4px' }}>
                                    {modifiedValue > workoutScore ? (
                                      <img src={booster} alt="Boosted" />
                                    ) : (
                                      <img src={Debooster} alt="Deboosted" />
                                    )}
                                  </span>
                                )}
                              {modifiedValue !== null && !isNaN(modifiedValue)
                                ? modifiedValue.toFixed(2)
                                : 'N/A'}
                            </div>
                          )
                        })}
                    </div> */}
                  </div>
                </PopContent>
              }
              key={index}
            >
              <div
                className="workout-item"
                style={{
                  width:
                    index === workouts.length - 1
                      ? `calc(${workout.width} - 2px)`
                      : workout.width,
                  left: workout.left,
                  background: workout.activity_type_shown === 'Sleep Booster' ? '#5C00D1' : 'inherit'
                }}
              ></div>
            </Popover>
          )
        })}
      </div>
    )
  }
}

export function getBarPCTWidth(pct = 0, ranges = []) {
  // if (pct > 500) {
  //   pct = 500
  // }
  const rangeCount = ranges.length - 1
  const targetRangeIndex = ranges.findIndex(
    (value, index) =>
      value <= pct && (ranges[index + 1] > pct || !ranges[index + 1])
  )

  let widthPCT = targetRangeIndex * (100 / rangeCount)
  if (pct > ranges[targetRangeIndex] && ranges[targetRangeIndex + 1]) {
    const extra = pct - ranges[targetRangeIndex]
    widthPCT +=
      ((extra / (ranges[targetRangeIndex + 1] - ranges[targetRangeIndex])) *
        100) /
      rangeCount
  }

  return widthPCT
}
